import { render, staticRenderFns } from "./winnerslider.vue?vue&type=template&id=8f9482c8&scoped=true"
import script from "./winnerslider.vue?vue&type=script&lang=js"
export * from "./winnerslider.vue?vue&type=script&lang=js"
import style0 from "./winnerslider.vue?vue&type=style&index=0&id=8f9482c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9482c8",
  null
  
)

export default component.exports